import { IGetApiRequestParams, ILooseObject } from '@/src/types/common.interface';
import AppUtils from '@/src/utils/AppUtils';

export enum COMMON_API_URLS_ENUM {
  COMMON_GET_USER_DATA = 'COMMON_GET_USER_DATA',
  GET_AUTH2_ACCESS_TOKEN = 'GET_AUTH2_ACCESS_TOKEN'
}

type GET_COMMON_API_URL_TYPE = IGetApiRequestParams & {
  url: COMMON_API_URLS_ENUM;
  data?: ILooseObject;
};

abstract class CommonApiConfig {
  public static GetCommonApiUrl({ url, filters }: GET_COMMON_API_URL_TYPE): string {
    if (url === COMMON_API_URLS_ENUM.COMMON_GET_USER_DATA) {
      return `${process.env.REACT_APP_CENTRAL_AUTH_API_BASE_URL}/v2/user/me`;
    } else if (url === COMMON_API_URLS_ENUM.GET_AUTH2_ACCESS_TOKEN) {
      return AppUtils.formatGetApiParameters(
        `${process.env.REACT_APP_AUTH_SERVICE_BASE_URL}/auth/outlook/retrieve-access-token`,
        { filters }
      );
    } else {
      return '';
    }
  }
}

export default CommonApiConfig;
